import React from "react";
import ComingSoon from "@/Utility/ComingSoon/ComingSoon";

const FieldsSettings = () => {
  return (
    <div className="bg-surface-primary border border-border-primary rounded-md shadow-sm p-6">
      <ComingSoon title="Fields settings" />
    </div>
  );
};

export default FieldsSettings;
